import { RESOURCES, RESOURCE_ORDER } from './Game/definitions.js'

export default class OssuaryUI
{
    constructor(_options)
    {
        this.state = _options.state
        this.openButton = document.querySelector('.js-ossuary-open')
        this.panel = document.querySelector('.js-ossuary-panel')
        this.closeButton = document.querySelector('.js-ossuary-close')
        this.rows = new Map()
        this.isOpen = false
        const list = document.querySelector('.js-ossuary-resources')
        for(const resource of RESOURCE_ORDER)
        {
            const row = document.createElement('div')
            row.className = 'ossuary-row'
            row.innerHTML = `<span class="ossuary-name">${RESOURCES[resource].label}</span><span class="ossuary-count" data-count="${resource}"></span><button type="button" data-action="withdraw" data-resource="${resource}" aria-label="Withdraw one ${RESOURCES[resource].label}">−</button><button type="button" data-action="deposit" data-resource="${resource}" aria-label="Deposit one ${RESOURCES[resource].label}">+</button><button type="button" class="ossuary-all" data-action="withdraw-all" data-resource="${resource}">ALL OUT</button><button type="button" class="ossuary-all" data-action="deposit-all" data-resource="${resource}">ALL IN</button>`
            list.appendChild(row)
            this.rows.set(resource, row.querySelector('[data-count]'))
        }
        this.openButton.addEventListener('click', () => this.setOpen(true))
        this.closeButton.addEventListener('click', () => this.setOpen(false))
        list.addEventListener('click', (_event) =>
        {
            const button = _event.target.closest('button[data-action]')
            if(!button)
                return
            const all = button.dataset.action.endsWith('-all')
            const direction = button.dataset.action.startsWith('deposit') ? 'deposit' : 'withdraw'
            this.state.transferOssuary(button.dataset.resource, direction, all)
            this.sync()
        })
        this.panel.addEventListener('keydown', (_event) =>
        {
            if(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'KeyW', 'KeyA', 'KeyS', 'KeyD'].includes(_event.code))
                _event.stopPropagation()
        })
        document.addEventListener('keydown', (_event) =>
        {
            if(_event.key === 'Escape' && this.isOpen)
                this.setOpen(false)
        })
    }

    setOpen(_open)
    {
        this.isOpen = _open
        this.panel.classList.toggle('is-open', _open)
        this.panel.inert = !_open
        this.panel.setAttribute('aria-hidden', String(!_open))
        if(_open)
            this.sync()
    }

    sync()
    {
        for(const resource of RESOURCE_ORDER)
            this.rows.get(resource).textContent = `${this.state.inventory[resource]} / ${this.state.ossuary.stored[resource]}`
    }

    update()
    {
        const near = this.state.ossuary.revealed && Math.hypot(this.state.player.x - this.state.ossuary.x, this.state.player.y - this.state.ossuary.y) <= 3.2
        this.openButton.hidden = !near || this.isOpen
        if(!near && this.isOpen)
            this.setOpen(false)
        if(this.isOpen)
            this.sync()
    }
}
